import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import Main from "../views/Main.vue";

import RequestList from "../components/RequestList.vue";
import VisitList from "../components/VisitList.vue";
import NotificationList from "../components/NotificationList.vue";
import NotificationDetail from "../components/NotificationDetail.vue";
import RequestDetail from "../components/RequestDetail.vue";
import BudgetList from "../components/BudgetList.vue";
import BudgetDetail from "../components/BudgetDetail.vue";
import ChargeList from "../components/ChargeList.vue";
import ChargeDetail from "../components/ChargeDetail.vue";
import ChatDetail from "../components/ChatDetail.vue";
import BillView from "../views/BillView.vue";
import BillDetailsView from "../views/BillDetailsView.vue";
import BillFormView from "../views/BillFormView.vue";
import AlternativeFormView from "../views/AlternativeFormView.vue";
import NotFound from "../views/NotFound.vue";
import NetworkIssue from "../views/NetworkIssue.vue";
import { auth } from "../plugins/firebase";
import LoginErrorView from "../views/LoginErrorView.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "*",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/main",
      component: Main,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          redirect: "request-list",
        },
        {
          path: "request-list",
          name: "request-list",
          component: RequestList,
        },
        {
          path: "visit-list",
          name: "visit-list",
          component: VisitList,
        },
        {
          path: "bill-list",
          name: "bill-list",
          component: BillView,
        },
        {
          path: "bill-form",
          name: "bill-form",
          component: BillFormView,
        },
        {
          path: "alternative-form",
          name: "AlternativeFormView",
          component: AlternativeFormView,
        },
        {
          path: "bill-details/:id",
          name: "bill-details",
          component: BillDetailsView,
          props: true,
        },
        {
          path: "notification-list",
          name: "notification-list",
          component: NotificationList,
        },
        {
          path: "notification-detail",
          name: "notification-detail",
          component: NotificationDetail,
        },
        {
          path: "request-detail/:id",
          name: "request-detail",
          component: RequestDetail,
          props: true,
          meta: { flush: true },
        },
        {
          path: "budget-list",
          name: "budget-list",
          component: BudgetList,
        },
        {
          path: "budget-detail",
          name: "budget-detail",
          component: BudgetDetail,
        },
        {
          path: "charge-list",
          name: "charge-list",
          component: ChargeList,
        },
        {
          path: "charge-detail",
          name: "charge-detail",
          component: ChargeDetail,
        },
        {
          path: "chat-detail",
          name: "chat-detail",
          component: ChatDetail,
        },
      ],
    },
    {
      path: "/404",
      name: "404",
      component: NotFound,
      props: true,
    },
    {
      path: "/network-issue",
      name: "network-issue",
      component: NetworkIssue,
    },
    {
      path: "/login-error",
      name: "login-error",
      component: LoginErrorView,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
